import GlobalConfig from './GlobalConfig/globalConfig';

export const baseUrlHomePageSearch=() =>{
    const origin = window.location.origin;
    switch (origin){
        case "https://dev-nsws.investindia.gov.in":
            return 'https://dev-nsws.investindia.gov.in';
        case "https://mpf-nsws.investindia.gov.in":
            return 'https://mpf-nsws.investindia.gov.in';
        case "https://qa-nsws.investindia.gov.in":
            return `https://qa-nsws.investindia.gov.in`;
        case "https://uat-nsws.investindia.gov.in":
            return `https://uat-nsws.investindia.gov.in`;
        case "https://www.ppe.nsws.gov.in":
            return `https://www.ppe.nsws.gov.in`;
        case "https://www.nsws.gov.in":
            return `https://www.nsws.gov.in`;
        case "https://www.demo.nsws.gov.in":
            return `https://www.demo.nsws.gov.in`;
        default:
            return `https://uat-nsws.investindia.gov.in`;
    }
};

export const searchDataApi = {
    method: 'POST',
    url: `${baseUrlHomePageSearch()}/gateway-sec/form-builder-sec/marketplace/license-summary-unified-list`,
    headers: GlobalConfig.getHeaders(['JSON'])
};
export const searchStateDataApi = {
    method: 'POST',
    url: `${baseUrlHomePageSearch()}/gateway-sec/form-builder-sec/marketplace/state-license-summary-list`,
    headers: GlobalConfig.getHeaders(['JSON'])
};

export const searchAllSchemeDataApi = {
    method: 'GET',
    headers: GlobalConfig.getHeaders(['JSON'])
};